export default "__VITE_ASSET__Dui1VDPM__"